import request from '@/axios'

export function fetchCustomFields (payload, customerId) {
  return request({
    url:`/attributes/${payload}/${customerId}`,
    method:'GET'
  })
}

export function fetchCustomFieldsV2 (payload, customerId) {
  return request({
    url:`/attributes/v2/${payload}/${customerId}`,
    method:'GET'
  })
}

export function createCustomField (payload) {
  return request({
    url:'/attributes/create',
    method: 'POST',
    data: payload
  })
}

export function deleteCustomField (payload) {
  return request({
    url:'/attributes/deleteattributes',
    method: 'POST',
    data: payload
  })
}

export function updateCustomField (payload) {
  return request({
    url:'/attributes/updateattributes',
    method: 'PUT',
    data: payload
  })
}


export function fetch_custom_modules () {
  return request({
    url:'/attributes/types_and_entities',
    method:'GET'
  })
}
export function fetch_single_attributes (query) {
  return request({
    url:`/attributes/fetchattributes/${query}`,
    method:'GET'
  })
}

export function DeleteMultiOption (query) {
  return request({
    url:`/attributes/deleteoptionvalue/${query}`,
    method:'GET'
  })
}

export function fetchCustomStaticFields (module_id, customerId, payload) {
  return request({
    url:`/field_settings/get_module_related_fields/${module_id}/${customerId}`,
    method:'GET',
    data:payload
  })
}

export function saveChecked (payload) {
  return request({
    url:'/field_settings/save',
    method: 'POST',
    data: payload
  })
}